import type { LogEntry } from "@/lib/types";
import { AnimatedNumber } from "@/components/ui/AnimatedNumber";
import { t } from "@/lib/i18n";

export function LogStats({ logs }: { logs: LogEntry[] }) {
  const errors = logs.filter((l) => l.level === "ERROR" || l.level === "FATAL").length;
  const warns = logs.filter((l) => l.level === "WARN").length;
  const clients = new Set(logs.map((l) => l.client_id)).size;

  return (
    // Auch mobil in einer Reihe — vier kompakte Kacheln statt 2×2, damit die
    // Log-Liste darunter möglichst weit oben beginnt.
    <div className="mb-3 grid grid-cols-4 gap-2 md:mb-4 md:gap-3">
      <Stat label={t("Sichtbar")} value={logs.length} />
      <Stat label={t("Errors")} value={errors} tone="destructive" />
      <Stat label={t("Warnings")} value={warns} tone="warning" />
      <Stat label={t("Clients")} value={clients} />
    </div>
  );
}

function Stat({
  label,
  value,
  tone = "default",
}: {
  label: string;
  value: number;
  tone?: "default" | "destructive" | "warning";
}) {
  const toneClass =
    tone === "destructive"
      ? "text-destructive"
      : tone === "warning"
        ? "text-warning"
        : "text-foreground";
  return (
    <div className="min-w-0 rounded-md bg-muted/60 px-2 py-1.5 md:px-3 md:py-2">
      <div className="truncate text-[10px] text-muted-foreground md:text-[11px]">{label}</div>
      <div className={`text-base font-medium tabular-nums md:text-lg ${toneClass}`}>
        <AnimatedNumber value={value} />
      </div>
    </div>
  );
}
